//angular imports
import {
    Injectable,
    OnDestroy
} from '@angular/core';

//ngx imports
import { IndividualConfig, ToastrService } from 'ngx-toastr';

// //local imports
import { Messenger } from '@app/shared';

import { 
    ToastComponent, 
    ToastLevel, 
    ToastMessage 
} from '@app/components';

@Injectable({
    providedIn: 'root',
})
export class ToastService implements OnDestroy {

    constructor(
        private toastr: ToastrService,
        private messenger: Messenger) { }

    public startListening() {
                         
        //TODO:DIW:Dedupe, gather messages in a short time frame into a single toast
        this.messenger.subscribe(this, ToastMessage, (message: ToastMessage) => {
                       
            let toastInformation: Partial<IndividualConfig<ToastMessage>> = {
                timeOut: message.timeout,
                progressBar: message.progressBar,
                positionClass: 'toast-top-right',
                toastClass: 'ngx-toastr',
                closeButton: message.closeButton,
                toastComponent: ToastComponent, // Use the custom component for the toast
                payload: message, // Pass the message object as payload                                    
            };

            switch(message.level){
                case ToastLevel.Information:
                    this.toastr.info('', '', toastInformation);
                    break;
                case ToastLevel.Success:
                    this.toastr.success('', '', toastInformation);
                    break;
                case  ToastLevel.Warning:
                    this.toastr.warning('', '', toastInformation);
                    break;
                default:
                    this.toastr.show('', '', toastInformation);
                    break;
            }


        });
    }

    ngOnDestroy() {
        this.messenger.unsubscribeByOwner(this);
    }
}


